import { GBLI_PHONE_EVENTS } from "@gbli-events/common/src/Constants/shared";
const ConfirmationError = () => {
  return (
    <div className="d-flex align-items-center justify-content-center mh--hf container">
      <div>
        Your payment was received successfully, however we experienced a
        technical issue while trying to create your policy. Please call{" "}
        <a href={`tel:${GBLI_PHONE_EVENTS}`} className="text-underline">
          1-{GBLI_PHONE_EVENTS}
        </a>{" "}
        option 2. For further assistance. We apologize for the inconvenience.
      </div>
    </div>
  );
};

export default ConfirmationError;
